/**
 * @module support/shared/widgets
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PdlWrapperService } from '@core/services/pdl-wrapper.service';

@Component({
  selector: 'tmo-form',
  template: '',
})
export class FormPdlComponent implements OnInit, OnDestroy {
  /**
   *  class - string - primary/secondary/tertiary
   */
  @Input() public formName?: string;

  constructor(private pdlWrapperService: PdlWrapperService) {}
  public ngOnInit(): void {
    if (this.formName) {
      this.formName = this.formName.slice(
        this.formName.lastIndexOf('#') + 1 || 0,
        this.formName.length
      );
      this.pdlWrapperService.formStartNameArr.push(this.formName);
      // this.pdlService.triggerCustomEvent(this.pdlPageComponentId, 'formLoad');
    }
  }

  public ngOnDestroy(): void {}
}
